export default __webpack_public_path__ + "static/media/TheTechBlog.ef153d03.gif";